import React from 'react';
import PropTypes from 'prop-types';
import { Trans } from 'react-i18next';

class BasicRadio extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};

    this._handleChange = this._handleChange.bind(this);
  }
  static propTypes = {
    touched: PropTypes.any,
    errors: PropTypes.any,
    handleChange: PropTypes.any,
    handleBlur: PropTypes.any,
    values: PropTypes.any,
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    help: PropTypes.string,
    options: PropTypes.array,
    noFormGroup: PropTypes.bool,
    ajaxErrors: PropTypes.object,
    setFieldValue: PropTypes.func
  };

  _handleChange(e) {
    this.props.setFieldValue(this.props.name, e.target.value);
  }

  render() {
    const {
      touched,
      errors,
      handleBlur,
      values,
      name,
      label,
      help,
      options,
      noFormGroup,
      ajaxErrors,
        extra
    } = this.props;

    return (
      <div
        className={
          (touched[name] && errors[name]) ||
          (ajaxErrors && !touched[name] && ajaxErrors[name])
            ? (noFormGroup ? '' : 'form-group m-form__group ') + 'has-danger'
            : noFormGroup
            ? ''
            : 'form-group m-form__group '
        }
      >
        {label && (
          <label>
            <Trans>{label}</Trans> {extra}
          </label>
        )}
        <div className="m-radio-list">
          {options.map(option => (
            <label className="m-radio m-radio--bold" key={option.value}>
              <input
                type="radio"
                name={name}
                onChange={this._handleChange}
                onBlur={handleBlur}
                checked={values[name] === option.value}
                value={option.value}
              />{' '}
              <Trans>{option.label}</Trans>
              <span />
            </label>
          ))}
        </div>
        {help && <span className="m-form__help">{help}</span>}
        {touched[name] && errors[name] && (
          <div className="form-control-feedback">{errors[name]}</div>
        )}
      </div>
    );
  }
}

export default BasicRadio;
